import FoodFacilitiesList from './FoodFacilitiesList';
export type { FoodFacilitiesListProps, FoodFacility } from './FoodFacilitiesList.types';

export default FoodFacilitiesList;
